import { render } from "./newMembers.vue?vue&type=template&id=2b862bb1&scoped=true"
import script from "./newMembers.vue?vue&type=script&lang=js"
export * from "./newMembers.vue?vue&type=script&lang=js"

import "./newMembers.vue?vue&type=style&index=0&id=2b862bb1&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/itibo/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b862bb1"]])

export default __exports__